import { caseListBodyClasses, caseTableClasses } from "../common/caseListClasses";
import { cn } from "../../utils/classNames";
import XLoader from "./XLoader";

const tableWrapperClasses = 'overflow-x-auto';

const ListTable = ({
  headers = [],
  children,
  className,
  isLoading,
}) => {
  return (
    <div className={tableWrapperClasses}>
      <table className={cn(caseTableClasses, className)}>
        <thead>
          <tr>
            {headers.map((header, i) => (
              <th key={i} className={header.className}>
                {header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={caseListBodyClasses}>
          {isLoading ? (
            <tr>
              <td colSpan={headers.length}>
                <XLoader className="mt-8 mb-8" />
              </td>
            </tr>
          ) : children}
        </tbody>
      </table>
    </div>
  );
};

export default ListTable;
